module.exports = __webpack_public_path__ + "img/icon-chat-active.6807d170.svg";